module.exports = __webpack_public_path__ + "img/del.b9ff8120.svg";